<template>

    <form id="contact-form" action="/blackship/send" method="POST" class="space-y-8 sm:space-y-12 2xl:space-y-14 2.5xl:space-y-16 3xl:space-y-18">

        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="tryme" :value="validator">
        <input type="hidden" name="lang" :value="lang">

        <span class="relative w-full block">
            <span class="w-full flex flex-col relative text-white">
                <input @focus="validation.fullname.state = null" name="name" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " type="fullname" v-model="form.fullname" />
                <label class="text-white text-xxs absolute left-0 -top-5 font-alternate tracking-[3px] opacity-50 pointer-events-none peer-focus:!text-xxs peer-focus:-top-5 peer-placeholder-shown:text-sm peer-placeholder-shown:xl:text-xbase peer-placeholder-shown:top-0 transition-all w-full text-center uppercase">{{$root.translateString('name')}}</label>
            </span>
            <span v-if="validation.fullname.state != null" class="text-red-400 px-1.5 text-xxs uppercase font-alternate flex items-center justify-center mt-2">
                {{ validation.fullname.message }}
            </span>
        </span>

        <span class="relative w-full block">
            <span class="w-full flex flex-col relative text-white">
                <input @focus="validation.email.state = null" name="email" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " type="email" v-model="form.email" />
                <label class="text-white text-xxs absolute left-0 -top-5 font-alternate tracking-[3px] opacity-50 pointer-events-none peer-focus:!text-xxs peer-focus:-top-5 peer-placeholder-shown:text-sm peer-placeholder-shown:xl:text-xbase peer-placeholder-shown:top-0 transition-all w-full text-center uppercase">E-MAIL</label>
            </span>
            <span v-if="validation.email.state != null" class="text-red-400 px-1.5 text-xxs uppercase font-alternate flex items-center justify-center mt-2">
                {{ validation.email.message }}
            </span>
        </span>

        <!-- <span class="relative w-full block">
            <span class="w-full flex flex-col relative text-white">
                <input @focus="validation.phone.state = null" name="phone" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer" placeholder=" " type="tel" v-model="form.phone" />
                <label class="text-white text-xxs absolute left-0 -top-5 font-alternate tracking-[3px] opacity-50 pointer-events-none peer-focus:!text-xxs peer-focus:-top-5 peer-placeholder-shown:text-sm peer-placeholder-shown:xl:text-xbase peer-placeholder-shown:top-0 transition-all w-full text-center uppercase">{{$root.translateString('phone')}}</label>
            </span>
            <span v-if="validation.phone.state != null" class="text-red-400 px-1.5 text-xxs uppercase font-alternate flex items-center justify-center mt-2">
                {{ validation.phone.message }}
            </span>
        </span> -->

        <span class="flex flex-col sm:flex-row space-y-10 sm:space-y-0 w-full justify-center items-center sm:space-x-3 !mt-12">
            <span class="flex-grow flex flex-col space-y-4">

                <span class="flex flex-grow flex-col">
                    <span class="flex items-center space-x-3">
                        <span class="w-[30px] h-[30px] relative block">
                            <input @click="validation.privacy.state = null" name="contact-privacy" id="contact-privacy" class="absolute top-0 left-0 w-full h-full opacity-0 accent-transparent outline-none ring-0" type="checkbox" v-model="form.privacy">
                            <span class="fake-checkbox absolute top-0 left-0 w-full h-full pointer-events-none bg-no-repeat bg-center border border-white/50"></span>
                        </span>
                        <label for="contact-privacy" class="cursor-pointer">
                            <span class="text-white/50 text-lg lg:text-xl">
                                {{$root.translateString('accept')}}
                            </span>
                            <a class="underline text-white/50 hover:text-white/100 text-xl transition-all" :href="'/' + lang + '/privacy-policy'">
                                {{$root.translateString('link')}}
                            </a>
                        </label>
                    </span>
                    <span v-if="validation.privacy.state != null" class="text-red-400 px-1.5 text-xxs uppercase font-alternate flex items-center justify-start mt-2">
                        {{ validation.privacy.message }}
                    </span>
                </span>

                <span class="flex items-center space-x-3">
                    <span class="w-[30px] h-[30px] relative block">
                        <input name="marketing" id="marketing" class="absolute top-0 left-0 w-full h-full opacity-0 accent-transparent outline-none ring-0" type="checkbox" v-model="form.marketing">
                        <span class="fake-checkbox absolute top-0 left-0 w-full h-full pointer-events-none bg-no-repeat bg-center border border-white/50"></span>
                    </span>
                    <label for="marketing" class="cursor-pointer">
                        <span class="text-white/50 text-lg block lg:text-xl !leading-none">
                            {{$root.translateString('marketing')}}
                        </span>
                    </label>
                </span>

            </span>
            <span>
                <button v-if="!loading" @click="checkForm" type="button" class="relative flex items-center group transition-all space-x-3.5">
                    <span class="rounded-full bg-white/20 group-hover:bg-white w-[40px] h-[40px] flex justify-center items-center transition-all">
                        <svg class="text-primary-400" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21.414px" height="15.683px" viewBox="0 0 21.414 15.683" enable-background="new 0 0 21.414 15.683" xml:space="preserve">
                            <g>
                                <line fill="none" stroke="currentColor" stroke-miterlimit="10" x1="0" y1="7.841" x2="20.715" y2="7.841"/>
                                <polyline fill="none" stroke="currentColor" stroke-miterlimit="10" points="13.219,0.354 20.707,7.841 13.219,15.329 	"/>
                            </g>
                        </svg>
                    </span>
                    <span class="text-primary-400 text-xbase font-alternate tracking-[3px] group-hover:text-white transition-all">
                        {{$root.translateString('send')}}
                    </span>
                </button>
                <svg class="h-[30px] w-[30px] text-white" v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                </svg>
            </span>
        </span>
    </form>

</template>

<script>
    export default {

        props: ['lang'],

        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                error: false,
                sending: false,
                validator: null,
                loading: false,
                form: {
                    fullname: '',
                    email: '',
                    phone: '',
                    message: '',
                    privacy: false,
                    marketing: false,
                },
                validation: {
                    fullname: {
                        state: null,
                        message: '',
                    },
                    email: {
                        state: null,
                        message: '',
                    },
                    phone: {
                        state: null,
                        message: '',
                    },
                    message: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
            }
        },
        methods: {

            checkForm() {

                this.sending = true;
                let error = false;

                Object.keys(this.validation).forEach(key => {
                    this.validation[key].state = null;
                });

                if(this.form.fullname == '') {
                    this.validation.fullname.message = this.$root.translateString('form-mandatory');
                    this.validation.fullname.state = false;
                    error = true;
                }

                if(this.form.email == '') {
                    this.validation.email.message = this.$root.translateString('form-mandatory');
                    this.validation.email.state = false;
                    error = true;
                }

                if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email))) {
                    this.validation.email.message = this.$root.translateString('form-format');
                    this.validation.email.state = false;
                    error = true;
                }

                // if(this.form.phone == '' || ( this.form.phone != '' && !(/^[+()\d-]+$/.test(this.form.phone)) ) ) {
                //     this.validation.phone.message = this.$root.translateString('form-format');
                //     this.validation.phone.state = false;
                //     error = true;
                // }

                if(this.form.privacy === false) {
                    this.validation.privacy.message = this.$root.translateString('form-mandatory');
                    this.validation.privacy.state = false;
                    error = true;
                }

                if(!error) {
                    this.loading = true
                    this.validator = '64Tg6Jhx!z_';
                    this.sendMail()
                }else{
                    this.sending = false;
                }

            },

            sendMail() {

                if(this.validator == '64Tg6Jhx!z_') {

                    setTimeout(() => {
                        document.querySelector('#contact-form').submit()
                    }, 500);

                }else{

                    return false

                }

            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
